// MVP LAB Mock Data

export const siteInfo = {
  name: "MVP LAB",
  tagline: "Play. Perform. Belong.",
  description: "Where sport meets community. More than a club. A lifestyle.",
  phone: "+971 4 385 6937",
  email: "reception@mvplab.ae",
  address: "29a St-Al Quoz Industrial Area 3 - Dubai",
  googleMapsUrl: "https://maps.app.goo.gl/BZ56fEGQSAnkcNFK6",
  instagramUrl: "https://www.instagram.com/mvplab.uae/",
  whatsappUrl: "https://wa.me/97143856937",
  bookingUrl: "https://footpad.doinsport.club/home",
  appStoreUrl: "https://apps.apple.com/ua/app/mvp-lab/id6471453843?l=uk",
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.trenicom.mvplab&hl=en"
};

export const services = [
  {
    id: "padel",
    title: "Padel",
    shortDescription: "Premium Indoor Panoramic courts",
    description: "Play Padel on the best indoor panoramic courts. MVP LAB ensures a special 365 days a year experience. Enjoy the game in a setting made for excellence!",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/6xyg6z6j_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.00.45.png",
    thumbnail: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/6xyg6z6j_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.00.45.png",
    icon: "CircleDot"
  },
  {
    id: "football",
    title: "Football",
    shortDescription: "5-a-side enclosed pitches with video system",
    description: "Experience 5-a-side soccer like never before in our enclosed structure. More playing time, fewer interruptions. Elevate your skills and creativity with our exclusive video system capturing game stats and highlights. Our expertly turf pitches prioritize optimal gameplay and minimize injury risks.",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/zmcu7k96_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.01.05.png",
    thumbnail: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/zmcu7k96_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.01.05.png",
    icon: "Goal"
  },
  {
    id: "yoga",
    title: "Yoga & Reformer Pilates",
    shortDescription: "Studio for mind-body wellness",
    description: "Discover tranquility in our yoga studio, where serenity meets purpose. Immerse yourself in a harmonious space designed for yoga enthusiasts of all levels. Our studio offers a peaceful retreat, fostering well-being through expertly guided practices. Join us in the journey to balance, flexibility, and inner peace.",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/eekdv7um_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.00.20.png",
    thumbnail: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/eekdv7um_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.00.20.png",
    icon: "Flower2"
  },
  {
    id: "coldplunge",
    title: "Cold Plunge",
    shortDescription: "Recovery and rejuvenation therapy",
    description: "Experience the power of cold therapy with our premium cold plunge facilities. Reduce inflammation, boost recovery, and enhance your overall well-being. Our cold plunge sessions are designed to help athletes and wellness enthusiasts recover faster and perform better.",
    image: "https://customer-assets.emergentagent.com/job_fitness-center-3/artifacts/r8cgfgr4_icebath.jpeg",
    thumbnail: "https://customer-assets.emergentagent.com/job_fitness-center-3/artifacts/r8cgfgr4_icebath.jpeg",
    icon: "Snowflake"
  },
  {
    id: "sauna",
    title: "Sauna",
    shortDescription: "Relaxation and detoxification",
    description: "Unwind and detoxify in our state-of-the-art sauna facilities. Experience deep relaxation while promoting muscle recovery, improving circulation, and cleansing your body. The perfect complement to your training routine.",
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676e463be23b1b93367dede7_Rectangle%2019-min.avif",
    thumbnail: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676ec5e51cf654b30b1c506e_Image-1-min.avif",
    icon: "Flame"
  },
  {
    id: "birthday",
    title: "Birthday Parties",
    shortDescription: "Unforgettable sports-themed celebrations",
    description: "Celebrate your special day with a sports-themed birthday party at MVP LAB! Our dedicated event spaces, exciting games, and expert staff make for an unforgettable celebration. Customize your package with optional add-ons, including catering and exclusive access to our facilities.",
    image: "https://customer-assets.emergentagent.com/job_fitness-center-3/artifacts/wkkm1uv6_birthday.png",
    thumbnail: "https://customer-assets.emergentagent.com/job_fitness-center-3/artifacts/wkkm1uv6_birthday.png",
    icon: "Cake"
  },
  {
    id: "corporate",
    title: "Corporate Events",
    shortDescription: "Team building and private events",
    description: "Transform your corporate events into memorable experiences at MVP LAB. From team building activities to private tournaments, we offer customized packages for businesses looking to engage their teams through sports and wellness activities.",
    image: "https://customer-assets.emergentagent.com/job_fitness-center-3/artifacts/jr8zirsn_Capture%20d%E2%80%99e%CC%81cran%202025-12-25%20a%CC%80%2014.53.14.png",
    thumbnail: "https://customer-assets.emergentagent.com/job_fitness-center-3/artifacts/jr8zirsn_Capture%20d%E2%80%99e%CC%81cran%202025-12-25%20a%CC%80%2014.53.14.png",
    icon: "Building2"
  },
  {
    id: "urbanball",
    title: "Urban Ball Academy",
    shortDescription: "Football freestyle & skills with Sean Garnier",
    description: "Train with Urban Ball FC Dubai, founded by world-famous freestyler Sean Garnier. Master football skills, freestyle techniques, and creative moves in our state-of-the-art indoor facilities. Programs available for all ages and skill levels.",
    image: "https://customer-assets.emergentagent.com/job_74a6f4ab-e5b2-4852-8d73-10c9661e1966/artifacts/kg0lo9iz_image.png",
    thumbnail: "https://customer-assets.emergentagent.com/job_74a6f4ab-e5b2-4852-8d73-10c9661e1966/artifacts/kg0lo9iz_image.png",
    icon: "Trophy",
    externalLink: "https://urbanballfc.com/"
  },
  {
    id: "padel-academy",
    title: "MVP Padel Academy",
    shortDescription: "Professional padel training for all ages",
    description: "Join our MVP Padel Academy and learn from our expert coaches Xavier, Samuel, and Claudia. We offer programs for kids, beginners, and advanced players. Develop your technique, strategy, and match play skills on our premium panoramic courts.",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/f2xnf3hc_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.00.01.png",
    thumbnail: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/f2xnf3hc_Capture%20d%E2%80%99e%CC%81cran%202025-12-19%20a%CC%80%2019.00.01.png",
    icon: "GraduationCap"
  }
];

export const whatsappCommunities = [
  {
    id: "mixed-padel",
    title: "Mixed Padel",
    description: "Open padel community for all. Find partners, join games, and compete in tournaments.",
    icon: "Trophy",
    link: "https://chat.whatsapp.com/Iz31n72O24k9E4f1IkdJgl",
    members: "Active Community"
  },
  {
    id: "breakfast-padel",
    title: "Padel Breakfast Club",
    description: "Early morning padel sessions for fitness enthusiasts. Start your day with an energizing game!",
    icon: "Sun",
    link: "https://chat.whatsapp.com/GrOXsBHVFQn6IHUMkELFZk",
    members: "Active Community"
  },
  {
    id: "ladies-padel",
    title: "Ladies Padel",
    description: "Exclusive padel community for women. Connect, play, and grow together.",
    icon: "Users",
    link: "https://chat.whatsapp.com/IKEcQdCOmiTGfZ7nAH76pc",
    members: "Active Community"
  },
  {
    id: "kids-padel",
    title: "Kids Padel Academy",
    description: "Padel community for young players and their parents. Stay updated on kids' programs and events.",
    icon: "Baby",
    link: "https://chat.whatsapp.com/CAx1GJkBUDJDchaoO5SYgf",
    members: "Active Community"
  },
  {
    id: "wellness",
    title: "Wellness (Reformer & More)",
    description: "Community for yoga, pilates, reformer, and recovery enthusiasts. Share tips and join classes.",
    icon: "Heart",
    link: "https://chat.whatsapp.com/JKZLgaY1bT8Hbln4TsVCBH",
    members: "Active Community"
  },
  {
    id: "football",
    title: "MVP LAB Football Community",
    description: "Join our football community for match updates, team formations, and friendly games.",
    icon: "Goal",
    link: "https://chat.whatsapp.com/JyQEqbtoL7a67JRhhCBTO8",
    members: "Active Community"
  },
  {
    id: "padel-matchmaking",
    title: "Padel Matchmaking",
    description: "Find padel partners at your level. Connect and arrange games with other players.",
    icon: "Racquet",
    link: "https://chat.whatsapp.com/BYxi72i6STIL6DOiwpErJ4",
    members: "Active Community"
  }
];

export const events = [
  {
    id: 1,
    title: "Summer Padel Championship 2025",
    date: "August 15-17, 2025",
    category: "Tournament",
    description: "Annual summer tournament featuring top padel players from across the UAE.",
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676ec5e5475e456fda359968_Image-6-min.avif"
  },
  {
    id: 2,
    title: "Corporate League Season 3",
    date: "September 1 - October 30, 2025",
    category: "League",
    description: "Multi-sport corporate league for companies in Dubai. Football & Padel competitions.",
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676ec5e575878aed7d11994c_Image-7-min.avif"
  },
  {
    id: 3,
    title: "Kids Sports Camp",
    date: "August 5-30, 2025",
    category: "Academy",
    description: "Summer sports camp for children aged 6-14. Daily activities, coaching, and fun!",
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676ec5e53ac96b3f1ba0622c_Image-4-min.avif"
  },
  {
    id: 4,
    title: "Wellness Weekend",
    date: "August 23-24, 2025",
    category: "Special Event",
    description: "A weekend dedicated to wellness featuring yoga sessions, recovery workshops, and more.",
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676ec5e5c683862e33345a93_Image-5-min.avif"
  }
];

export const venues = [
  {
    id: "padel-courts",
    title: "Padel Courts",
    description: "3 Premium Indoor Panoramic courts for the best padel experience",
    features: ["Air-conditioned", "LED lighting", "Panoramic views", "Equipment rental"]
  },
  {
    id: "football-pitches",
    title: "Football Pitches",
    description: "5 enclosed 5-a-side pitches with video capture system for game analysis",
    features: ["4 pitches with artificial grass", "1 pitch with Urban SBR surface", "Video analysis system", "Floodlights"]
  },
  {
    id: "reformer-studio",
    title: "Reformer Studio",
    description: "Dedicated reformer pilates studio with professional equipment",
    features: ["Professional reformer machines", "Expert instructors", "All equipment provided", "Air-conditioned"]
  },
  {
    id: "yoga-studio",
    title: "Yoga Studio",
    description: "Peaceful space designed for yoga practice and mindfulness",
    features: ["Peaceful ambiance", "Professional instructors", "All mats & props provided", "Natural lighting"]
  },
  {
    id: "ballroom",
    title: "Ballroom",
    description: "Versatile event space for parties, corporate events, and special occasions",
    features: ["Flexible setup", "Event catering available", "Audio-visual equipment", "Private hire"]
  },
  {
    id: "recovery-zone",
    title: "Recovery Zone",
    description: "Sauna and ice bath facilities for optimal post-workout recovery",
    features: ["Finnish sauna", "Ice bath therapy", "Private sessions", "Towel service"]
  },
  {
    id: "working-area",
    title: "Working Area",
    description: "Co-working space for remote work between sessions",
    features: ["Free high-speed WiFi", "Comfortable seating", "Power outlets", "Quiet environment"]
  },
  {
    id: "parking",
    title: "Parking",
    description: "Convenient on-site parking for all visitors",
    features: ["Free parking", "Ample spaces", "Easy access", "Secure area"]
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676d51c96cc1912ecfb91d71_Frame%201000004343-min.avif",
    link: "https://www.instagram.com/mvplab.uae/"
  },
  {
    id: 2,
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676d51ca744bf2c7bbecc656_Frame%201000004345-min.avif",
    link: "https://www.instagram.com/mvplab.uae/"
  },
  {
    id: 3,
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676d51ca72d1e888a5f8139d_Frame%201000004344-min.avif",
    link: "https://www.instagram.com/mvplab.uae/"
  },
  {
    id: 4,
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676d51caca6f29e601635833_Frame%201000004346-min.avif",
    link: "https://www.instagram.com/mvplab.uae/"
  },
  {
    id: 5,
    image: "https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676d51c99615722376d80d84_Frame%201000004347-min.avif",
    link: "https://www.instagram.com/mvplab.uae/"
  }
];

export const aboutContent = {
  story: "MVP LAB is Dubai's premier multi-sports and wellness destination, where passion meets performance. Founded with the vision of creating a community-driven sports hub, we bring together world-class facilities, expert coaching, and a vibrant community of sports enthusiasts.",
  mission: "To inspire and empower individuals through sport, fostering a community where everyone can play, perform, and belong.",
  values: [
    {
      title: "Performance",
      description: "World-class facilities and coaching to help you reach your potential",
      icon: "Target"
    },
    {
      title: "Community",
      description: "Building connections through shared passion for sports",
      icon: "Users"
    },
    {
      title: "Lifestyle",
      description: "More than a club – a way of life centered on health and wellness",
      icon: "Heart"
    },
    {
      title: "Education",
      description: "Continuous learning and skill development for all ages",
      icon: "BookOpen"
    },
    {
      title: "Well-being",
      description: "Holistic approach to physical and mental health",
      icon: "Sparkles"
    }
  ],
  vision2026: "By 2026, MVP LAB aims to be the leading sports and lifestyle destination in the Middle East, expanding our footprint while maintaining our commitment to excellence, community, and innovation."
};

export const padelCoaches = [
  {
    id: "xavier-masson",
    name: "Xavier Masson",
    role: "Head Coach",
    languages: ["French", "English"],
    instagram: "https://www.instagram.com/xavier_masson",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/79mu9jrj_Xavier.png"
  },
  {
    id: "samuel-martinez",
    name: "Samuel Martinez",
    role: "Padel Coach",
    languages: ["Spanish", "English"],
    instagram: "https://www.instagram.com/samueelmaartinezz",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/4m52rzo0_Sam.png"
  },
  {
    id: "claudia-puig",
    name: "Claudia Puig",
    role: "Padel Coach",
    languages: ["Spanish", "English"],
    instagram: "https://www.instagram.com/claudiapuig98",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/rtrr4j9v_Claudia.png"
  }
];

export const reformerCoaches = [
  {
    id: "anna",
    name: "Anna",
    role: "Reformer Coach",
    description: "Certified Reformer Pilates Instructor passionate about transforming bodies and lives through mindful movement. With a focus on strength, flexibility, and posture, Anna creates personalized sessions that help clients feel stronger, balanced, and confident.",
    instagram: "https://www.instagram.com/anna_reformerpilates_dxb",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/c1cmrjbo_Capture%20d%E2%80%99e%CC%81cran%202025-12-21%20a%CC%80%2020.43.48.png",
    imagePosition: "face-focus"
  },
  {
    id: "angela",
    name: "Angela",
    role: "Reformer Coach",
    description: "Angela Pandelis is a renowned Greek American aerial dancer & contortion performer and certified yoga/pilates instructor with workshops worldwide. She studied in New York and her teaching career in Dubai started in 2017.",
    instagram: "https://www.instagram.com/angelapandelis",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/9f7d9oxd_angela.jpeg"
  },
  {
    id: "aziza",
    name: "Aziza",
    role: "Reformer Coach",
    description: "A French sport physiotherapist and Pilates instructor, Aziza combines her clinical knowledge with mindful movement. With over 2 years of experience, her classes emphasize mobility, strength, and coordination while preventing injuries and supporting women's health.",
    instagram: "https://www.instagram.com/azizaminds",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/9mnx3t24_aziza.png"
  },
  {
    id: "olga",
    name: "Olga",
    role: "Reformer Coach",
    description: "Certified Fitness Trainer with 9+ years of international experience. Over 10,000 group training sessions and 8,000 private sessions worldwide. Personal Trainer Level 3 Diploma, REPs Approved (UAE), specializing in Pilates, Stretching, and Functional Training.",
    instagram: "https://www.instagram.com/olga_diaczenko_",
    image: "https://customer-assets.emergentagent.com/job_2ec39b0b-77ab-415a-a039-1ccac228dff1/artifacts/o2etlszb_Olga.png"
  }
];

export const heroImages = [
  "https://customer-assets.emergentagent.com/job_74a6f4ab-e5b2-4852-8d73-10c9661e1966/artifacts/you4q432_MVP_LAB_02072024_A%20%2876%29-Enhanced-NR.JPG",
  "https://customer-assets.emergentagent.com/job_74a6f4ab-e5b2-4852-8d73-10c9661e1966/artifacts/jgqt6q4a_MVP_LAB_02072024_A%20%28336%29-Enhanced-NR.JPG",
  "https://customer-assets.emergentagent.com/job_74a6f4ab-e5b2-4852-8d73-10c9661e1966/artifacts/ek6jiz3o_MVP_LAB_02072024_B%20%28560%29-Enhanced-NR.JPG"
];
